exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".not-active {\r\n    pointer-events: none;\r\n    cursor: default;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Projects/Empower360Plus/EmpowerWeb2.0/A4.Empower/A4.Empower/ClientApp/src/app/layout/admin/breadcrumbs/breadcrumbs.component.css
// module id = ../../../../../src/app/layout/admin/breadcrumbs/breadcrumbs.component.css
// module chunks = main